var cookies = (function () {
  function getAllCookies() { 
    return document.cookie.split(';');
  }

  function getCookieValue(name) { 
    for (const cookie of getAllCookies()) {
      if (cookie.trim().startsWith(name + '=')) {
        return cookie.trim().replace(name + '=', '');
      }
    }
    return null;
  }

  function removeCookie(name) { 
    if (cookieExists(name)) {
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    }
  }

  function cookieExists(name) { 
    return document.cookie.includes(name + '=');
  }
  
  return {
    getCookieValue: getCookieValue,
    removeCookie: removeCookie,
    cookieExists: cookieExists
  };
})();
  
export default cookies;